import React from 'react'
import { useSelector } from 'react-redux'
import './dashboard.scss'


const NewOffers = () => {
  const offerStats = useSelector((s) => s?.adminReducer?.dashboardOfferStats);

  // Determine frequency (Today, Weekly, Monthly, Yearly)
  const frequency = (typeof window !== 'undefined' && window.__ADMIN_SELECTED_FREQUENCY__) || 'Monthly';
  const f = String(frequency || '').toLowerCase();

  // Helpers for current month/year
  const now = new Date();
  const monthNames = ['january','february','march','april','may','june','july','august','september','october','november','december'];
  const currentMonthKey = monthNames[now.getMonth()];
  const currentYearKey = String(now.getFullYear());

  // Prefer explicit keys by timeframe if present
  const inferByFrequency = (stats) => {
    if (!stats) return undefined;
    // Backend shapes we have seen (example in your screenshot):
    // { today, weekly: { ... }, weeklyTotal, monthlyTotal, monthlyBreakdown: {...}, yearlyBreakdown: {...} }
    if (f === 'today') return stats.today ?? stats.todays ?? stats.newToday;
    if (f === 'weekly') {
      const total = stats.weeklyTotal ?? stats.weekTotal;
      if (total !== undefined) return total;
      if (stats.weekly && typeof stats.weekly === 'object') {
        return Object.values(stats.weekly).reduce((a, b) => a + (Number(b) || 0), 0);
      }
      return undefined;
    }
    if (f === 'monthly') {
      // For monthly view, show ONLY the current month, not year-to-date
      const mb = stats.monthlyBreakdown || stats.monthly || stats.byMonth || stats.perMonth || stats.months;
      if (mb && typeof mb === 'object') {
        const lower = Object.fromEntries(Object.entries(mb).map(([k,v]) => [String(k).toLowerCase(), v]));
        const val = lower[currentMonthKey];
        if (val !== undefined) return Number(val) || 0;
      }
      // If backend provides currentMonth value separately
      return stats.currentMonth ?? stats.monthlyCurrent;
    }
    if (f === 'yearly') {
      const yt = stats.yearlyTotal ?? stats.yearTotal;
      if (yt !== undefined) return yt;
      const yb = stats.yearlyBreakdown || stats.byYear || stats.perYear;
      if (yb && typeof yb === 'object') {
        const val = yb[currentYearKey];
        if (val !== undefined) return Number(val) || 0;
      }
      return undefined;
    }
    return undefined;
  };

  // Fallbacks to generic counters
  const offersCount =
    inferByFrequency(offerStats) ??
    offerStats?.newOffers ??
    offerStats?.newOfferCount ??
    offerStats?.totals?.new ??
    offerStats?.new ??
    offerStats?.count ??
    0;

  return (
    <div className='newOffers w-[23%] mt-8 p-[0.35rem]'>
      <div className='flex items-center justify-start w-full gap-5'>
        <div className='bg-white rounded-[5px] px-8 text-center'>
          <span className='text-[24px] font-poppins font-[600] text-[black]'>{offersCount}</span>
        </div>
        <span className='text-[20px] font-poppins font-[400] text-[black] whitespace-nowrap'>New Offers</span>
      </div>
    </div>
  )
}

export default NewOffers
